import PageHeader from 'components/PageHeader';
import TabsGallery, { TabType } from 'components/TabsGallery';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useMemo } from 'react';
import { t } from 'utils/getTranslations';

import CoiCheckView from './views/CoiCheckView';
import PreviousCoiChecksView from './views/PreviousCoiChecksView';

const ConflictCheckReports = (): JSX.Element => {
    const tabComponents = useMemo(
        (): TabType[] => [
            {
                id: 'coi-check',
                label: t('coi.coi-check'),
                component: <CoiCheckView />,
            },
            {
                id: 'previous-coi-checks',
                label: t('coi.previous-coi-checks'),
                component: <PreviousCoiChecksView />,
            },
        ],
        []
    );

    return (
        <PaddedLayout>
            <PageHeader titleId="coi.coi-check" />
            <div className="h-4" />
            <TabsGallery tabs={tabComponents} tabGroupId="coi-check-reports" trackTabsInHistoryState />
        </PaddedLayout>
    );
};

export default ConflictCheckReports;
